import axios from 'axios';
import store from '../../modules/index';

const kota = 
{
    namespaced: true,
    state: {
        data_model:[],
    },
    mutations: 
    {
        FETCH_DATA: (state, payload) => {
            state.data_model  = payload;
        }
    },
    actions: {
       
        async all({ commit }) 
        {
            store.state.isLoading.status = true;
            return await axios.post('location/provinces-data',
            {
                order :{ key : 'id', value : 'asc' },
                query_type : 'all'
            })
            .then((response) => {
                commit("FETCH_DATA", response.data);
                return response.data;
            }).finally(() => {
                store.state.isLoading.status = false;
            });
        },
    }
}

export default kota